/**
 * Canonical READY presentation for Sherloc media platforms.
 *
 * Campaign Analysis reports the same readiness state twice: once as a chip in
 * Live Platforms, and once as a pill on the matching Platform Performance card.
 * They are one semantic state, so the treatment is named once here — and its
 * colors once in SherlocReports.css as --sherlocreports-ready-* — instead of
 * each section mapping READY to a class of its own. That drift is exactly how
 * READY came to render green above and ice-blue below.
 *
 * Measurement pills are deliberately NOT canonical READY. GA4 reports on a
 * connection rather than on media readiness, so it keeps the ice-blue
 * .sherlocreports-source-pill-ready and its own LIVE SIGNAL / PARTIAL / SETUP
 * states. AVAILABLE keeps it too: it is a different status, not a Ready.
 */

/** The Live Platforms chip. Canonical source of the Ready treatment. */
export const SHERLOC_LIVE_PLATFORM_STATUS_CLASS =
  "sherlocreports-live-platform-status";

/** The Platform Performance modifier that resolves to that same treatment. */
export const SHERLOC_READY_PILL_MODIFIER_CLASS =
  "sherlocreports-source-pill-platform-ready";

export const SHERLOC_READY_PILL_CLASS = `sherlocreports-source-pill ${SHERLOC_READY_PILL_MODIFIER_CLASS}`;

/** The ice-blue pill this state must never fall back to. */
export const SHERLOC_MEASUREMENT_PILL_CLASS = "sherlocreports-source-pill-ready";

export const SHERLOC_READY_LABEL = "READY";

export const SHERLOC_READY_TITLE =
  "Approved in the current media plan; waiting on current delivery evidence";

/**
 * The Platform Performance pill for a platform that is approved for this report
 * context but has not yet returned delivery.
 */
export const buildSherlocReadyPill = (title = SHERLOC_READY_TITLE) => ({
  label: SHERLOC_READY_LABEL,
  className: SHERLOC_READY_PILL_CLASS,
  title,
});
